import { EventListPresenterState } from "../../../blocks/EventListPresenter/state";
import { BaseDict } from "../../../blocks/EventListPresenter/dict";
import { Event } from "../../../contracts";
import { getFixtureCardProps } from "../getFixtureCardProps";

//added tests webpack issue
/* istanbul ignore next */
export const getOutrightCardProps = (state: EventListPresenterState, event: Event, cms: any, dict: BaseDict) => {
    return event.isLive
            ? getFixtureCardProps(state, event, cms, dict)
            : {
                event,
                markets: state.displayMarkets(event.id),
                handlers: {
                    betButton: state.addToSlipTranspiler.bind(state)
                },
                showHeadingNames: state.shouldShowOutrightSubheading,
                numberOfSelectionsToShow: cms.NumberOfSelectionsToShow,
                viewAllProps: {
                    linkUrl: event.linkUrl,
                    onClick: state.openGameTranspiler.bind(state, event),
                    text: dict.ViewAllOutrights
                },
                dict: BaseDict
            }
}